import React, { useState, useCallback, useEffect } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha, Typography } from "@mui/material";
import theme from "src/config/theme";
import { ReactComponent as Profile } from '../../../../../assets/images/profile-circle.svg';
import { ReactComponent as ArrowRight } from '../../../../../assets/images/arrow-right 2.svg';
import { ReactComponent as SliderVertical } from '../../../../../assets/images/slider-vertical.svg';
import { ReactComponent as Edit2 } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../../../assets/images/close-circle.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg'
import ButtonComponent from "src/components/shared/Button";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import AppointmentTabForm from "../Forms/AppointmentTabForm";
import NoDataFound from "../../NoDataFound/NoDataFound";
import useResponsive from "src/components/hooks/useResponsive";
import { useParams } from 'react-router-dom';
import { getAppointmentByPatientIdRequest } from "src/modules/app/store/appActions";
import { useDispatch, useSelector } from "react-redux";
import useAppointmentDetails from "../../UseAppointmentDetails";
import { AllTabsMainContainer } from "../Style";
import AppointmentCard from "../CardView/AppointmentCard";
import dayjs from "dayjs";

const columns = [
  { id: "appointmentIdCol", label: "Appt ID", sx: { width: "150px", minWidth: "100px", textAlign: 'left' } },
  { id: "patientIdCol", label: "Patient ID", sx: { width: "150px", minWidth: "100px", textAlign: 'left' } },
  { id: "appointments", label: "Appointments", sx: { width: "300px", minWidth: "150px", textAlign: 'left' } },
  { id: "symptoms", label: "Symptoms", sx: { width: "900px", textAlign: 'left !important' } },
  {
    id: "status", label: "Status", sx: {
      textAlign: 'center !important',
      "& .css-axw7ok": { justifyContent: 'center' }
    }
  },
];

const actions = [
  { label: "View Profile", icon: <Profile width={24} height={24} />, onClick: (row) => alert(`Viewing ${row.patient}`) },
  { label: "Attend Now", icon: <ArrowRight width={24} height={24} />, onClick: (row) => alert(`Attending ${row.patient}`) },
  { label: "Add to Queue", icon: <SliderVertical width={24} height={24} />, onClick: (row) => alert(`Adding ${row.patient} to Queue`) },

];


const Appointments = ({ shouldRefresh }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState();
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const { PatientId } = useAppointmentDetails();
  const dispatch = useDispatch();
  const [appointments, setAppointments] = useState([]);
 
  const fetchAppointments = useCallback(
    (page = 0, perPage = 10) => {
      const fetchData = async () => {
        const params = {
          page: page + 1,
          limit: perPage,
        };
        const response = await new Promise((resolve, reject) => {
          dispatch(getAppointmentByPatientIdRequest({ patientId: PatientId, params }, resolve, reject));
        });

        if (response?.data && response?.meta) {

          setAppointments(response.data);
          setTotalCount(response.meta.totalRecords);

        } else {
          console.log('Error fetching notes');
        }
      }
      fetchData();
    },
    [dispatch, PatientId],
  );
  useEffect(() => {
    if (PatientId) {
      fetchAppointments(page, perPage);
    }
  }, [PatientId, fetchAppointments, page, perPage, shouldRefresh]);


  const data = appointments.map((appointment) => ({
    id: appointment.id,
    appointmentIdCol: (
      <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
        {appointment.appointmentId || 'APT-N/A'}
      </Typography>
    ),
    patientIdCol: (
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontWeight: 500 }}>
        {appointment.patient?.patientId || 'MYC-N/A'}
      </Typography>
    ),
    symptoms: appointment.addnotes,
    status: (
      <Chip
        label={appointment.recordStatus}
        sx={{
          background:
            appointment.recordStatus === "Scheduled" ? "linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))" :
              appointment.recordStatus === "In Queue" ? "linear-gradient(0deg, rgba(103, 57, 150, 0.14), rgba(103, 57, 150, 0.14))" :
                appointment.recordStatus === "Attending Now" ? "linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))" :
                  appointment.recordStatus === "Complete" ? "linear-gradient(0deg, rgba(57, 150, 57, 0.18), rgba(57, 150, 57, 0.18))" :
                    appointment.recordStatus === "Cancelled" ? "linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18))" :
                      appointment.recordStatus === "Overdue" ? "linear-gradient(0deg, rgba(150, 57, 57, 0.18), rgba(150, 57, 57, 0.18))" :
                        appointment.recordStatus === "Treatment Scheduled" ? "linear-gradient(0deg, rgba(150, 57, 150, 0.12), rgba(150, 57, 150, 0.12))" :

                          "linear-gradient(0deg, rgba(200, 200, 200, 0.18), rgba(200, 200, 200, 0.18))",
          color:
            appointment.recordStatus === "Scheduled" ? theme.palette.action.purpleDark :
              appointment.recordStatus === "In Queue" ? theme.palette.action.purpleLight :
                appointment.recordStatus === "Attending Now" ? theme.palette.action.green :
                  appointment.recordStatus === "Complete" ? theme.palette.action.green :
                    appointment.recordStatus === "Cancelled" ? theme.palette.action.red :
                      appointment.recordStatus === "Overdue" ? theme.palette.action.red :
                        appointment.recordStatus === "Treatment Scheduled" ? theme.palette.action.purpleDark :
                          theme.palette.gery.black,
          ...theme.typography.small,
          borderRadius: '100px',
          padding: '10px 18px 8px 18px',
        }}
      />
    ),
    appointments: `${dayjs(appointment.date).format("DD-MM-YYYY")}, ${(appointment.time)}`

  }));

  return (
    <>
      <AllTabsMainContainer>

        {(isMobile || isTablet) ?
          <AppointmentCard
            appointments={appointments}
            page={page}
            perPage={perPage}
            setPage={setPage}
            totalCount={totalCount}
            fetchAppointments={fetchAppointments}
          />
          :
          <CustomTable
            columns={columns}
            data={data}
            actions={actions}
            page={page}
            disabled={true}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            headerButton={
              <ButtonComponent
                variant="contained"
                endIcon={<Add width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} />}
                onClick={handleOpen}
                sx={{
                  background: theme.palette.primary.main,
                  border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                  boxShadow: theme.shadows[1],
                  minWidth: '187px',
                  height: '36px',
                  padding: '6px 6px 6px 10px',
                  borderRadius: '12px',
                  ...theme.typography.h5,
                  // position: 'absolute',
                  // left: '370px'
                  // left: 'auto'
                }}
              >Add Appointment</ButtonComponent>
            }
            noDataComponent={
              <NoDataFound
                title="No Appointments Found!"
                buttonText="Add Appointment"
                buttonIcon={Add}
                onClick={handleOpen}
              />
            }
          />
        }

        <DialogBox open={open}  >
          <AppointmentTabForm onClose={handleClose} fetchAppointments={fetchAppointments} />

        </DialogBox>

      </AllTabsMainContainer>
    </>
  )
};

export default Appointments;

